module.exports = __webpack_public_path__ + "img/icon-snapchat.f6af883e.svg";